import React from 'react';

const SVG = ({
  style = {},
  fill = '#fff',
  width = '100%',
  className = '',
  title = 'ERisk',
  viewBox = '0 0 115 45',
}) => (
  <svg
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .cls-2,.cls-3{fill:${fill};stroke:transparent}.cls-3{fill:#f77619}
        `}
      </style>
    </defs>

    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Isolation_Mode" data-name="Isolation Mode">
        <path
          id="Path_5714"
          data-name="Path 5714"
          className="cls-2"
          d="M313.338 185.758a5 5 0 0 1-1.147-.106 1.582 1.582 0 0 1-.632-.284.844.844 0 0 1-.282-.42 2.5 2.5 0 0 1-.089-.7V171.8a1.479 1.479 0 0 1 .393-1.122c.179-.176.63-.385 1.758-.385h.2l.234-.471-.153-1.121h-7.779v1.592h.32a2.3 2.3 0 0 1 1.581.375 1.481 1.481 0 0 1 .388 1.132v5.288h-9.136V171.8a1.486 1.486 0 0 1 .392-1.122c.18-.175.632-.385 1.758-.385h.2l.235-.471-.155-1.121h-7.779v1.592h.32a2.3 2.3 0 0 1 1.582.375 1.481 1.481 0 0 1 .389 1.132v12.453a1.474 1.474 0 0 1-.389 1.131 2.3 2.3 0 0 1-1.582.375h-.32v1.592h7.779l.155-1.121-.235-.472h-.2a5.021 5.021 0 0 1-1.147-.106 1.588 1.588 0 0 1-.632-.284.84.84 0 0 1-.281-.423 2.422 2.422 0 0 1-.09-.693v-5.392h9.136v5.392a1.477 1.477 0 0 1-.388 1.131 2.3 2.3 0 0 1-1.581.375h-.32v1.592h7.779l.153-1.119-.234-.473z"
          transform="translate(-233.408 -162.151)"
        />
        <path
          id="Path_5715"
          data-name="Path 5715"
          className="cls-2"
          d="M392.648 191.7h-.807l-4.274.68-.149 1.079.236.472h.2a2.746 2.746 0 0 1 1.557.284 1.264 1.264 0 0 1 .336 1.043v6.073a4.015 4.015 0 0 1-.656.947 3.12 3.12 0 0 1-.769.6 2.974 2.974 0 0 1-.8.29 3.306 3.306 0 0 1-2.077-.155 2.05 2.05 0 0 1-.781-.622 2.369 2.369 0 0 1-.408-.919 5.658 5.658 0 0 1-.121-1.193V191.7h-.781l-4.294.652-.188 1.122.288.458h.177a2.767 2.767 0 0 1 1.529.292 1.2 1.2 0 0 1 .364 1.036v5.557a4.949 4.949 0 0 0 1.136 3.4 4.307 4.307 0 0 0 3.379 1.291 4.78 4.78 0 0 0 4-1.845v1.49l.456.4 4.61-1.631V202.9l-2.162-.438z"
          transform="translate(-299.568 -180.004)"
        />
        <path
          id="Path_5716"
          data-name="Path 5716"
          className="cls-2"
          d="M458.464 167.936a5.161 5.161 0 0 0-1.781-1.55 5.546 5.546 0 0 0-2.647-.592 4.9 4.9 0 0 0-.882.1 4.457 4.457 0 0 0-1.125.387 5.618 5.618 0 0 0-1.173.79 4.357 4.357 0 0 0-.565.593v-8.534l-.455-.4-4.611 1.631v1.051l2.161.463v14.408a12.922 12.922 0 0 1-.1 1.542 7.162 7.162 0 0 1-.32 1.44l-.088.253.844.475.171-.153a2.375 2.375 0 0 1 .825-.5 2.031 2.031 0 0 1 1.379-.04c.228.077.489.161.787.249s.625.17.986.25a6.13 6.13 0 0 0 1.29.123 6.5 6.5 0 0 0 2.8-.584 6 6 0 0 0 2.079-1.6 7.046 7.046 0 0 0 1.268-2.371 9.493 9.493 0 0 0 .426-2.862 10.068 10.068 0 0 0-.293-2.405 6.25 6.25 0 0 0-.976-2.164zm-6.865.527a3.757 3.757 0 0 1 .78-.273 3.133 3.133 0 0 1 .652-.083 3.356 3.356 0 0 1 1.658.384 3.172 3.172 0 0 1 1.122 1.053 5.14 5.14 0 0 1 .665 1.622 9.774 9.774 0 0 1 0 4.15 5.141 5.141 0 0 1-.654 1.611 3.148 3.148 0 0 1-1.051 1.029 3.067 3.067 0 0 1-2.325.26 3.154 3.154 0 0 1-.875-.35 3.4 3.4 0 0 1-.787-.647 2.33 2.33 0 0 1-.495-.887v-6.668a2.432 2.432 0 0 1 .546-.7 3.363 3.363 0 0 1 .765-.501z"
          transform="translate(-351.076 -154.408)"
        />
        <path
          id="Path_5717"
          data-name="Path 5717"
          className="cls-2"
          d="M512.847 175.044a.92.92 0 0 0-.2-.159.588.588 0 0 0 .373-.174.5.5 0 0 0 .125-.35.538.538 0 0 0-.081-.3.43.43 0 0 0-.22-.181 1.367 1.367 0 0 0-.439-.051h-.8v1.886h.381v-.787h.077a.65.65 0 0 1 .192.02.308.308 0 0 1 .114.078 2.667 2.667 0 0 1 .2.279l.274.41h.455l-.231-.369a2.274 2.274 0 0 0-.22-.302zm-.586-.414h-.281v-.478H512.558a.242.242 0 0 1 .143.075.229.229 0 0 1 .051.154.255.255 0 0 1-.039.141.206.206 0 0 1-.107.08 1.5 1.5 0 0 1-.344.028z"
          transform="translate(-402.6 -166.135)"
        />
        <path
          id="Path_5718"
          data-name="Path 5718"
          className="cls-2"
          d="M508.425 169.471a1.921 1.921 0 1 0 1.921 1.921 1.925 1.925 0 0 0-1.921-1.921zm0 3.5a1.578 1.578 0 1 1 1.575-1.579 1.581 1.581 0 0 1-1.575 1.579z"
          transform="translate(-398.645 -162.749)"
        />
        <path
          id="Path_5719"
          data-name="Path 5719"
          className="cls-3"
          d="M34.313 198.161A3.1 3.1 0 0 0 35.924 195a1.614 1.614 0 0 0-.384-.9 2.561 2.561 0 0 0-.783-.587 3.587 3.587 0 0 0-1.073-.32 8.338 8.338 0 0 0-1.222-.089 6.5 6.5 0 0 0-3.142.831 9.7 9.7 0 0 0-4.427 5.075 6.578 6.578 0 0 0-.415 3.169 5.566 5.566 0 0 0 1.308 3.145 3.608 3.608 0 0 0 2.809 1.176 7.189 7.189 0 0 0 2.454-.4 6.859 6.859 0 0 0 1.935-1.061 6.158 6.158 0 0 0 1.4-1.572 10.083 10.083 0 0 0 .927-1.9l-.913-.333a7.763 7.763 0 0 1-.641 1.087 5.624 5.624 0 0 1-.894 1 4.623 4.623 0 0 1-1.12.728 3.2 3.2 0 0 1-1.354.281 2.323 2.323 0 0 1-.639-.09 1.369 1.369 0 0 1-.594-.356 2.512 2.512 0 0 1-.5-.742 4.123 4.123 0 0 1-.311-1.214 10.438 10.438 0 0 1-.08-1.3 9.268 9.268 0 0 1 .088-1.252q4.104-.026 5.96-1.215zM28.99 196.9a6.3 6.3 0 0 1 .8-1.393 3.947 3.947 0 0 1 .953-.908 1.812 1.812 0 0 1 .992-.333q1 0 1.106.844a2.585 2.585 0 0 1-.128 1.061 2.978 2.978 0 0 1-.7 1.151 4.155 4.155 0 0 1-1.386.933 5.679 5.679 0 0 1-2.162.409 8.176 8.176 0 0 1 .525-1.764z"
          transform="translate(-24.431 -181.102)"
        />
        <path
          id="Path_5720"
          data-name="Path 5720"
          className="cls-2"
          d="M188.723 199.77a9.877 9.877 0 0 0-1.623-.851 16.067 16.067 0 0 1-1.623-.772 5.531 5.531 0 0 1-1.25-.916 1.761 1.761 0 0 1-.5-1.3 1.88 1.88 0 0 1 .2-.9 1.769 1.769 0 0 1 .5-.593 2.057 2.057 0 0 1 .669-.335 2.492 2.492 0 0 1 .671-.1 3.462 3.462 0 0 1 1.443.27 2.693 2.693 0 0 1 .952.7 2.56 2.56 0 0 1 .516.954 3.755 3.755 0 0 1 .156 1.069l.541-.052.258-.129.489-3.5-.283-.206a3.013 3.013 0 0 1-1.314.284 5.546 5.546 0 0 1-1.225-.143 6.464 6.464 0 0 0-1.4-.141 5.647 5.647 0 0 0-1.483.206 4.311 4.311 0 0 0-1.378.644 3.582 3.582 0 0 0-1.018 1.108 3.435 3.435 0 0 0 .091 3.375 4.584 4.584 0 0 0 1.224 1.225 9.489 9.489 0 0 0 1.6.876q.863.373 1.6.773a5.6 5.6 0 0 1 1.225.875 1.576 1.576 0 0 1 .489 1.173 2.25 2.25 0 0 1-.219 1.043 1.855 1.855 0 0 1-.58.683 2.441 2.441 0 0 1-.8.374 3.3 3.3 0 0 1-.851.115 3.593 3.593 0 0 1-2.59-1.043 3.794 3.794 0 0 1-1.094-2.383l-.8.076-.207.181.258 3.3a7.9 7.9 0 0 0 1.456.516c.489.121.941.211 1.352.271a9.48 9.48 0 0 0 1.057.1c.292.009.49.013.592.013a5.389 5.389 0 0 0 1.739-.283 4.971 4.971 0 0 0 1.494-.8 3.922 3.922 0 0 0 1.043-1.223 3.243 3.243 0 0 0 .387-1.585 2.925 2.925 0 0 0-.5-1.753 4.706 4.706 0 0 0-1.264-1.196z"
          transform="translate(-146.044 -181.089)"
        />
        <path
          id="Path_5721"
          data-name="Path 5721"
          className="cls-2"
          d="M238.441 180.852a1.919 1.919 0 0 1-1.263-.747l-4.484-5.849v-.129l4.716-3.994 1.984-.439V169h-5.746v.7l2.215.439-5.023 4.689h-.748v-12.991l-.206-.181-4.226 1.495v.567l2.165.439v14.919a2.167 2.167 0 0 1-.465 1.481 2.2 2.2 0 0 1-1.7.528v.8h6.6l.1-.593-.1-.206a1.782 1.782 0 0 1-2.164-2.009v-3.53a2.6 2.6 0 0 1 .85.154 1.306 1.306 0 0 1 .49.335l3.529 5.025a2.551 2.551 0 0 0 1.1.863 3.647 3.647 0 0 0 1.4.27 4.167 4.167 0 0 0 1.663-.27 3.7 3.7 0 0 0 1.043-.683l.052-.18-.077-.1a12.546 12.546 0 0 1-1.705-.109z"
          transform="translate(-180.638 -156.683)"
        />
        <path
          id="Path_5722"
          data-name="Path 5722"
          className="cls-2"
          d="M156.776 165.686a1.65 1.65 0 0 0-1.186.5 1.654 1.654 0 0 0 0 2.4 1.69 1.69 0 1 0 1.186-2.9z"
          transform="translate(-125.845 -159.811)"
        />
        <path
          id="Path_5723"
          data-name="Path 5723"
          className="cls-2"
          d="M98.648 186.762a1.973 1.973 0 0 1-.464-1.429v-10.2l-.206-.18-4.226 1.495v.7l2.164.438v7.756a1.975 1.975 0 0 1-.464 1.429 2.3 2.3 0 0 1-1.644.474 10.615 10.615 0 0 1-3.187-3.218c-.229-.417-2.68-4.3-3.281-4.986a6.012 6.012 0 0 0 1.5-.618 5.057 5.057 0 0 0 1.34-1.121 4 4 0 0 0 .721-1.3 4.221 4.221 0 0 0 .219-1.3 7.153 7.153 0 0 0-.219-1.752 3.741 3.741 0 0 0-.862-1.6 4.614 4.614 0 0 0-1.8-1.172 8.513 8.513 0 0 0-3.041-.452h-7.162v.953a2.7 2.7 0 0 1 1.8.452 1.751 1.751 0 0 1 .49 1.353v12.5a1.793 1.793 0 0 1-.49 1.366 2.648 2.648 0 0 1-1.8.464v.953h7.188l.1-.747-.1-.206a5.3 5.3 0 0 1-1.224-.13 1.9 1.9 0 0 1-.76-.348 1.16 1.16 0 0 1-.386-.579 2.762 2.762 0 0 1-.1-.787v-5.436a6.823 6.823 0 0 1 1.959.219c.463.146 4.784 6.935 5.068 7.278a3.14 3.14 0 0 0 1.005.812 2.992 2.992 0 0 0 1.378.3h8.236l.1-.7-.1-.206a2.444 2.444 0 0 1-1.752-.475zM83.6 178.478h-.425a2.99 2.99 0 0 1-.425-.026v-5.976a1.854 1.854 0 0 1 .452-1.327 2.387 2.387 0 0 1 1.739-.478 5.3 5.3 0 0 1 1.817.271 3.264 3.264 0 0 1 1.2.734 2.6 2.6 0 0 1 .657 1.082 4.364 4.364 0 0 1 .193 1.315 5.541 5.541 0 0 1-.269 1.777 3.5 3.5 0 0 1-.876 1.392 4.019 4.019 0 0 1-1.6.913 8.057 8.057 0 0 1-2.463.323z"
          transform="translate(-66.042 -162.94)"
        />
        <path
          id="Path_5724"
          data-name="Path 5724"
          className="cls-3"
          d="M138.091 153.791a1.057 1.057 0 1 0-1.056-1.056 1.057 1.057 0 0 0 1.056 1.056z"
          transform="translate(-111.841 -148.937)"
        />
        <path
          id="Path_5725"
          data-name="Path 5725"
          className="cls-3"
          d="M156.1 142.5a1.537 1.537 0 1 0-1.538-1.537 1.538 1.538 0 0 0 1.538 1.537z"
          transform="translate(-125.446 -139.428)"
        />
        <path
          id="Path_5726"
          data-name="Path 5726"
          className="cls-3"
          d="M176.789 150.452a1.537 1.537 0 1 0-1.537-1.537 1.537 1.537 0 0 0 1.537 1.537z"
          transform="translate(-141.507 -145.599)"
        />
        <path
          id="Path_5727"
          data-name="Path 5727"
          className="cls-3"
          d="M185.728 171.1a1.057 1.057 0 1 0 1.058-1.057 1.058 1.058 0 0 0-1.058 1.057z"
          transform="translate(-149.639 -163.192)"
        />
        <path
          id="Path_5728"
          data-name="Path 5728"
          className="cls-3"
          d="M34.313 198.161A3.1 3.1 0 0 0 35.924 195a1.614 1.614 0 0 0-.384-.9 2.561 2.561 0 0 0-.783-.587 3.587 3.587 0 0 0-1.073-.32 8.338 8.338 0 0 0-1.222-.089 6.5 6.5 0 0 0-3.142.831 9.7 9.7 0 0 0-4.427 5.075 6.578 6.578 0 0 0-.415 3.169 5.566 5.566 0 0 0 1.308 3.145 3.608 3.608 0 0 0 2.809 1.176 7.189 7.189 0 0 0 2.454-.4 6.859 6.859 0 0 0 1.935-1.061 6.158 6.158 0 0 0 1.4-1.572 10.083 10.083 0 0 0 .927-1.9l-.913-.333a7.763 7.763 0 0 1-.641 1.087 5.624 5.624 0 0 1-.894 1 4.623 4.623 0 0 1-1.12.728 3.2 3.2 0 0 1-1.354.281 2.323 2.323 0 0 1-.639-.09 1.369 1.369 0 0 1-.594-.356 2.512 2.512 0 0 1-.5-.742 4.123 4.123 0 0 1-.311-1.214 10.438 10.438 0 0 1-.08-1.3 9.268 9.268 0 0 1 .088-1.252q4.104-.026 5.96-1.215zM28.99 196.9a6.3 6.3 0 0 1 .8-1.393 3.947 3.947 0 0 1 .953-.908 1.812 1.812 0 0 1 .992-.333q1 0 1.106.844a2.585 2.585 0 0 1-.128 1.061 2.978 2.978 0 0 1-.7 1.151 4.155 4.155 0 0 1-1.386.933 5.679 5.679 0 0 1-2.162.409 8.176 8.176 0 0 1 .525-1.764z"
          transform="translate(-24.431 -181.102)"
        />
        <path
          id="Path_5729"
          data-name="Path 5729"
          className="cls-3"
          d="M138.091 153.791a1.057 1.057 0 1 0-1.056-1.056 1.057 1.057 0 0 0 1.056 1.056z"
          transform="translate(-111.841 -148.937)"
        />
        <path
          id="Path_5730"
          data-name="Path 5730"
          className="cls-3"
          d="M156.1 142.5a1.537 1.537 0 1 0-1.538-1.537 1.538 1.538 0 0 0 1.538 1.537z"
          transform="translate(-125.446 -139.428)"
        />
        <path
          id="Path_5731"
          data-name="Path 5731"
          className="cls-3"
          d="M176.789 150.452a1.537 1.537 0 1 0-1.537-1.537 1.537 1.537 0 0 0 1.537 1.537z"
          transform="translate(-141.507 -145.599)"
        />
        <path
          id="Path_5732"
          data-name="Path 5732"
          className="cls-3"
          d="M185.728 171.1a1.057 1.057 0 1 0 1.058-1.057 1.058 1.058 0 0 0-1.058 1.057z"
          transform="translate(-149.639 -163.192)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
